export enum adminInvoiceDetailTypes {
    FETCH_ADMIN_INVOICE_DETAIL_REQUEST = "FETCH_ADMIN_INVOICE_DETAIL_REQUEST",
    FETCH_ADMIN_INVOICE_DETAIL_SUCCESS = "FETCH_ADMIN_INVOICE_DETAIL_SUCCESS",
    FETCH_ADMIN_INVOICE_DETAIL_FAILURE = "FETCH_ADMIN_INVOICE_DETAIL_FAILURE",
  }